/* 布局 */
//前台
import Layout from "@views/layout";

const orderservermealRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "orderservermeal/list",
        name: "ORDERSERVERMEAL",
        meta: {
            title: "VIP预约订单",
            keepAlive:true
        },
        component: () => import("@views/business/orderservermeal/index.vue"),
    },
        ],
};

export default orderservermealRouter;
